module.exports = "/assets/data/18740703c65e8510436e6a6ef3bf3c0b-DE45.data.json";